const copyToClipboard = async () => {
  await navigator.clipboard.writeText("ashvin.valentine281@gmail.com");
  alert(`copied ashvin.valentine281@gmail.com to clipboard!`);
};

export default copyToClipboard;